import {ItemPessoa} from "./item-pessoa";

export class ListaPessoa {
  itens: ItemPessoa[];
}
